import {useState, useEffect, useMemo} from 'react'
import {useSearchContext} from '../../../../search_input'

export const useExpandedGroups = ({items, groupProps = {}}) => {
	const {search} = useSearchContext()
	const {collapsable = true, collapseGroups} = groupProps
	const labels = useMemo(() => items.filter(i => i.type === 'group')._map('label'), [items])

	const [expandedGroups, setExpandedGroups] = useState(() => {
		if (!collapsable || !collapseGroups) return new Set(labels)
		return new Set()
	})

	useEffect(() => {
		if (search || !collapsable || !collapseGroups) {
			setExpandedGroups(new Set(labels))
		}
	}, [labels, search])

	const toggleGroupExpansion = label => {
		setExpandedGroups(prev => {
			const next = new Set(prev)
			next.has(label) ? next.delete(label) : next.add(label)
			return next
		})
	}

	return {expandedGroups, toggleGroupExpansion}
}
